<template>
    <div class="opt-check-list">
        <v-checkbox-group
            v-model="checkedArr"
            @change="handleGroupChange"
        >
            <v-checkbox
                v-for="item in options"
                :key="item.value"
                :value="item.value"
                :label="$t(item.text)"
            />
        </v-checkbox-group>
    </div>
</template>

<script>
export default {
  props: {
    options: {
      type: Array,
      default: () => [],
    },

    checkedList: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      checkedArr: [],
    };
  },

  watch: {
    options() {},
    checkedList(arr) {
      this.checkedArr = arr;
    },
  },

  created() {
    this.checkedArr = this.checkedList || [];
  },

  methods: {
    handleGroupChange(arr) {
      this.$emit('change', arr);
    },
  },
};
</script>
